import script from "./MuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MuButton.vue?vue&type=script&setup=true&lang=js"

import "./MuButton.vue?vue&type=style&index=0&id=0121c8e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0121c8e0"]])

export default __exports__